import PhotoPreview from './PhotoPreview.components';

export default PhotoPreview;
